<template>
  <v-container fluid class="vendor-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-account-outline</v-icon>
            Vendor
          </v-tab>
          <v-tab
            :href="`#tab-options`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-account-cog</v-icon>
            Options
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>
          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">Edit Vendor</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeVendor($event, 'vendorname')"
                        v-bind:value="initvalue.vendorname"
                        placeholder="Vendor Name"
                        persistent-hint
                        single-line hint="Enter the vendor name">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeVendor($event, 'vendorcode')"
                        v-bind:value="initvalue.vendorcode"
                        placeholder="Vendor Code"
                        persistent-hint
                        single-line hint="Enter the vendor code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeVendor($event, 'vendorcontact')"
                        v-bind:value="initvalue.vendorcontact"
                        placeholder="Contact Person"
                        persistent-hint
                        single-line hint="Enter the contact person">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="vendortypes"
                        :value="initvalue.vendortype"
                        outlined
                        dense
                        v-on:change="onChangeVendor($event, 'vendortype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the vendor type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="countries.map(x => {
                            return {text: x.countryname, value: x._id};
                          })"
                        :value="initvalue.countryid"
                        outlined
                        dense
                        v-on:change="onChangeVendor($event, 'countryid')"
                        placeholder="Country"
                        persistent-hint
                        single-line hint="Please choose the country">
                      </v-select>
                      <v-row no-gutters>
                          <v-col cols="12" md="6">
                            <v-switch
                              v-model="initvalue.vendorstatus"
                              v-on:change="onChangeVendor($event, 'vendorstatus')"
                              color="primary"
                              v-bind:label="initvalue.vendorstatus=='Active' ? initvalue.vendorstatus : 'Inactive'"
                              value="Active"
                              false-value="Inactive"
                              hint="Status"
                              persistent-hint
                            ></v-switch>
                          </v-col>
                          <v-col cols="12" md="6" class="ma-0">
                            <v-switch
                              color="primary"
                              v-model="initvalue.isPaymentNotify"
                              v-on:change="onChangeVendor($event, 'isPaymentNotify')"
                              hint="Notify Payment"
                              :false-value="false"
                              persistent-hint
                            ></v-switch>
                          </v-col>
                        </v-row>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-textarea
                        v-on:change="onChangeVendor($event, 'vendoraddress')"
                        v-bind:value="initvalue.vendoraddress"
                        outlined
                        rows=3
                        label="Address"
                        hint="please enter the vendor address"
                      ></v-textarea>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeVendor($event, 'vendorphone')"
                        v-bind:value="initvalue.vendorphone"
                        placeholder="Vendor Phone"
                        persistent-hint
                        single-line hint="Enter the vendor phone">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeVendor($event, 'vendormobile')"
                        v-bind:value="initvalue.vendormobile"
                        placeholder="Vendor Phone"
                        persistent-hint
                        single-line hint="Enter the vendor mobile">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeVendor($event, 'vendoremail')"
                        v-bind:value="initvalue.vendoremail"
                        placeholder="Vendor Email"
                        persistent-hint
                        single-line hint="Enter the vendor email">
                      </v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="6" sm="3">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/vendor/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editVendor()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            :value="'tab-options'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-form>
                      <p class="text-h5">Edit Options</p>
                      <v-textarea
                        v-on:change="onChangeVendorOptions($event, 'paymentdata')"
                        v-bind:value="initvalue.options.paymentdata"
                        outlined
                        rows=3
                        label="Payment Data"
                        hint="please enter the payment data"
                      ></v-textarea>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-form>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/vendor/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editOptionsRequest()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/vendor/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item></v-tab-item>
          <v-tab-item></v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      edit_vendor: {},
      photo: {},
      initvalue: {},
      change_options: {},
      imageurl: undefined,
      vendortypes: ['Vendor', 'Supplier', 'Other Vendor'],
    }
  },
  methods: {
    ...mapActions('Vendor', ['updateVendorRequest','updateVendorImageRequest','updateVendorOptionsRequest','getVendorsRequest']),
    ...mapActions('Country', ['getCountriesRequest']),
    async editVendor() {
      
      this.edit_vendor._id = this.initvalue._id;
      await this.updateVendorRequest(this.edit_vendor);
      router.push('/vendor/list');
    },
    async editPhoto() {
      this.photo._id = this.initvalue._id;
      this.updateVendorImageRequest(this.photo);
      await this.getVendorsRequest();
      router.push('/vendor/list');
    },
    async editOptionsRequest() {
      this.change_options._id = this.initvalue._id;
      await this.updateVendorOptionsRequest(this.change_options);
      router.push('/vendor/list');
    },
    onChangeVendor(value, field){
      if(field=='vendorstatus') this.edit_vendor[field] = (value=='Active' ? 'Active' : 'Inactive');
      else this.edit_vendor[field] = value;
    },
    onChangeVendorOptions(value, field){
      this.change_options[field] = value;
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.vendorimage = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('Vendor', ['isReceiving']),
    ...mapState('Country', ['countries']),
  },
  created () {
    this.initvalue = this.$route.params;
    this.imageurl = this.initvalue.vendorimage;
    if(!this.initvalue._id) this.$router.push({ name: 'VendorList' });
    if(this.countries.length==0) this.getCountriesRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
